import { render, staticRenderFns } from "./_rtfCommentary.vue?vue&type=template&id=43429cd8&lang=pug&"
import script from "./_rtfCommentary.vue?vue&type=script&lang=js&"
export * from "./_rtfCommentary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports